import {TranslationInterpreter} from '../../TranslationProvider/TranslationContext';
import {EmojiToolbarIcon} from '../components/ToolbarIcons';

export function getEmojiTriggerDefinition(t: TranslationInterpreter) {
  return {
    ariaLabel: t('richText.toolbar.insertEmoji'),
    icon: <EmojiToolbarIcon />,
  };
}
